import { render, staticRenderFns } from "./TmDataLoading.vue?vue&type=template&id=389ee65a&"
import script from "./TmDataLoading.vue?vue&type=script&lang=js&"
export * from "./TmDataLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports